import { motion } from "framer-motion";

const About = () => {
  return (
    <main className="min-h-screen bg-gradient-to-b from-[#0A0A0A] via-[#111111] to-[#0A0A0A]">
      <div className="absolute inset-0 bg-[url('/noise.png')] opacity-5 pointer-events-none"></div>
      <div className="relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h1 className="text-[40px] font-bold text-white mb-4">
              Biz Kimiz?
            </h1>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="max-w-4xl mx-auto space-y-8"
          >
            <motion.p
              className="text-center text-xl text-gray-300 leading-relaxed"
              whileHover={{ scale: 1.01 }}
              transition={{ duration: 0.2 }}
            >
              Kolektif Oluşum, Türkiye'nin ve Avrupa'nın en büyük öğrenci
              ağıdır. 2023 yılında İELEV Özel Lisesi'nde hayata geçirilen,
              liseli ve üniversiteli gençlerin arasındaki dayanışma ve
              işbirliğini güçlendirmek için kurulan bir kolektiftir. Oluşumun
              temel hedefi; okullar, şehirler ve ülkeler arasında öğrencilerin
              etkileşimini güçlendirerek zeki, çevik ve ahlaklı bir şekilde
              gelişmelerini sağlamaktır. Geniş kapsamlı etkinlikler,
              organizasyonlar, zirveler düzenleyerek Kolektif ruhunu yaymaktır.
            </motion.p>

            <motion.p
              className="text-center text-xl text-gray-300 leading-relaxed"
              whileHover={{ scale: 1.01 }}
              transition={{ duration: 0.2 }}
            >
              Kolektif Oluşum, Türkiye'nin ve Avrupa'nın en büyük öğrenci
              ağıdır. 2023 yılında İELEV Özel Lisesi'nde hayata geçirilen,
              liseli ve üniversiteli gençlerin arasındaki dayanışma ve
              işbirliğini güçlendirmek için kurulan bir kolektiftir. Oluşumun
              temel hedefi; okullar, şehirler ve ülkeler arasında öğrencilerin
              etkileşimini güçlendirerek zeki, çevik ve ahlaklı bir şekilde
              gelişmelerini sağlamaktır. Geniş kapsamlı etkinlikler,
              organizasyonlar, zirveler düzenleyerek Kolektif ruhunu yaymaktır.
            </motion.p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="max-w-5xl mx-auto mt-24 mb-24 bg-black/40 backdrop-blur-sm rounded-2xl p-12 border border-white/5"
          >
            <motion.blockquote
              className="text-3xl md:text-4xl italic text-center leading-relaxed text-white"
              whileHover={{ scale: 1.01 }}
              transition={{ duration: 0.2 }}
            >
              "Gençler, geleceği kuracak olanlardır. Onların hayal gücü ve
              cesareti, dünyayı değiştirme potansiyeline sahiptir."
            </motion.blockquote>
            <motion.p
              className="text-right text-xl text-blue-400 mt-6"
              whileHover={{ x: -5 }}
              transition={{ duration: 0.2 }}
            >
              -Yaşar Kemal
            </motion.p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="max-w-4xl mx-auto"
          >
            <h2 className="text-3xl font-bold text-white text-center mb-12">
              Temel İlkelerimiz
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {[
                {
                  title: "1. Eğitimde Mükemmeliyet",
                  content:
                    "Öğrencilerin akademik başarılarını artırmak ve eğitim süreçlerini desteklemek için çeşitli projeler ve programlar geliştiriyoruz. Amacımız, öğrencilerin bilimsel, sanatsal ve sportif alanlarda kendilerini geliştirebilecekleri fırsatlar sunmaktır.",
                },
                {
                  title: "2. Sosyal Dayanışma ve İletişim",
                  content:
                    "Farklı okullar ve kültürler arasında köprüler kurarak, gençlerin birbirleriyle daha güçlü bağlar oluşturmasını sağlıyoruz. Sosyal etkinlikler, kültürel değişim programları ve gönüllülük projeleriyle öğrenciler arasında kalıcı dostluklar ve iş birlikleri kurulmasını teşvik ediyoruz.",
                },
                {
                  title: "3. Liderlik ve Sorumluluk Bilinci",
                  content:
                    "Gençlerin liderlik vasıflarını geliştirmek ve toplumda aktif birer birey olmalarını sağlamak için eğitimler ve seminerler düzenliyoruz. Öğrencilere, sosyal sorumluluk projelerinde yer alma fırsatları sunarak, toplum bilincini ve duyarlılığını artırmayı hedefliyoruz.",
                },
                {
                  title: "4. Refah ve Eğlence",
                  content:
                    "Öğrencilerin okul ve kampüs hayatlarını daha keyifli hale getirmek için çeşitli sosyal ve kültürel etkinlikler düzenliyoruz. Amacımız, eğitim hayatını sadece akademik başarıyla değil, aynı zamanda güzel anılar ve dostluklarla da zenginleştirmektir.",
                },
              ].map((principle, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.8 + index * 0.1 }}
                  whileHover={{
                    scale: 1.02,
                    backgroundColor: "rgba(255, 255, 255, 0.05)",
                  }}
                  className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:border-blue-500/30"
                >
                  <h3 className="text-xl font-semibold text-white mb-4">
                    {principle.title}
                  </h3>
                  <p className="text-gray-300 leading-relaxed">
                    {principle.content}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </main>
  );
};

export default About;
